import api from './axiosNew';

export const sendAiMessage = (data) => api.post('/api/ai-chat/message', data);

export const getAiPresets = () => api.get('/api/ai-chat/presets');

export const getAiConfig = () => api.get('/api/ai-chat/config');

export const getAiMetadata = () => api.get('/api/ai-chat/metadata');
